import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import router from './router'
import uni from './js/uni.webview.1.5.6'
import axios from 'axios'
import { createPinia } from 'pinia'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import { fas } from '@fortawesome/free-solid-svg-icons'
import { showLoading, hideLoading } from './utils/loading'
import { v4 as uuidv4 } from 'uuid'
// 将图标添加到库中
library.add(fas)


const app = createApp(App)

app.use(ElementPlus, {
    locale: zhCn,
    resizeObserverOptions: {
        box: 'content-box'
    }
})

app.config.globalProperties.$loading = {
    show: showLoading,
    hide: hideLoading
}

// 同时挂载到window，方便非组件中调用（如axios拦截器）
window.$loading = {
    show: showLoading,
    hide: hideLoading
}

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.config.globalProperties.$uuid = uuidv4
app.use(router)
app.use(uni)
app.use(createPinia())
app.component('font-awesome-icon', FontAwesomeIcon)
app.config.globalProperties.$http = axios
app.provide('uuid', uuidv4)
app.mount('#app')
app._context.components.ElDialog.props.closeOnClickModal.default = false

const resizeObserverLoopErr = () => {
    const observer = new ResizeObserver(() => {});
    observer.observe(document.body);
    observer.disconnect();
};

if (typeof window !== 'undefined') {
    window.addEventListener('error', (e) => {
        if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
            e.stopImmediatePropagation();
        }
    });
    resizeObserverLoopErr();
}
